import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: "/product/list"
  },
  {
    path: "/product",
    component: () => import("@/views/product/index"),
    // redirect: "/index/list",
    meta: {
      title: "每日生鲜"
      // 缓存首页
      // keepAlive: true
    },
    children: [
      {
        path: "list",
        meta: {
          title: "商品列表",
          keepAlive: true
        },
        component: () => import("@/views/product/list/index")
      },
      {
        path: "detail/:productId",
        meta: {
          title: "商品详情"
        },
        component: () => import("@/views/product/detail/index")
      }
    ]
  },
  {
    path: "/chat",
    meta: {
      title: "客服"
    },
    component: () => import("@/views/chat/index")
  },
  {
    path: "/category",
    meta: {
      title: "分类",
      keepAlive: true,
    },
    component: () => import("@/views/category/index")
  },
  {
    path: "/footprint",
    meta: {
      title: "足迹"
    },
    component: () => import("@/views/footprint/index")
  },
  {
    path: "/favorite",
    meta: {
      title: "收藏"
    },
    component: () => import("@/views/favorite/index")
  },
  // 秒杀和拼团
  {
    path: "/activity",
    meta: {
      title: "活动"
    },
    component: () => import("@/views/activity/index"),
    children: [
      {
        path: 'seckill',
        meta: {
          title: '秒杀'
        },
        component: () => import("@/views/activity/children/seckill"),
      },
      {
        path: 'groupBuy',
        meta: {
          title: '秒杀'
        },
        component: () => import("@/views/activity/children/groupBuy"),
      }
    ]
  },
  {
    path: "/coupon",
    meta: {
      title: "优惠券"
    },
    component: () => import("@/views/coupon/index")
  },
  {
    path: "/cart",
    meta: {
      title: "购物车"
    },
    component: () => import("@/views/cart/index")
  },
  {
    path: "/address",
    meta: {
      title: "地址"
    },
    component: () => import("@/views/address/index"),
    children: [
      {
        path: "list",
        meta: {
          title: "地址列表"
        },
        component: () => import("@/views/address/children/list")
      },
      {
        path: "add",
        meta: {
          title: "添加地址"
        },
        component: () => import("@/views/address/children/edit")
      },
      {
        path: "edit/:addressId",
        meta: {
          title: "编辑"
        },
        component: () => import("@/views/address/children/edit")
      }
    ]
  },
  {
    path: "/order",
    component: () => import("@/views/order/index"),
    meta: {
      title: "订单"
    },
    children: [
      {
        path: "list",
        meta: {
          title: "订单列表"
        },
        component: () => import("@/views/order/list/index")
      },
      {
        path: "detail/:orderId",
        meta: {
          title: "订单详情"
        },
        component: () => import("@/views/order/detail/index")
      },
      {
        path: "submit",
        meta: {
          title: "确认订单"
        },
        component: () => import("@/views/order/submit/index")
      },
      {
        path: "pay",
        meta: {
          title: "支付订单"
        },
        component: () => import("@/views/order/pay/index")
      },
      {
        path: "coupon/:totalPrice",
        meta: {
          title: "优惠券"
        },
        component: () => import("@/views/order/submit/coupon")
      }
    ]
  },
  {
    path: "/my",
    component: () => import("@/views/my/index"),
    redirect: "/my/center",
    children: [
      {
        path: "center",
        meta: {
          title: "个人中心"
        },
        component: () => import("@/views/my/children/center")
      },
      {
        path: "set",
        meta: {
          title: "设置"
        },
        component: () => import("@/views/my/children/set")
      }
    ]
  },
  {
    path: "/login",
    component: () => import("@/views/account/index"),
    meta: {
      title: "登陆"
    }
  },
  {
    path: "/register",
    component: () => import("@/views/account/index"),
    meta: {
      title: "注册"
    }
  },
  {
    path: "/demo",
    component: () => import("@/components/demo")
  },
  // {
  //   path: "*",
  //   component: () => import("@/components/NotFound")
  // }
];
const router = new Router({
  mode: "history",
  scrollBehavior: () => ({
    y: 0
  }),
  routes
});

router.beforeEach((to, from, next) => {
  console.log(to);
  if (to.path.includes('/product/list')) {
    document.querySelector('html').classList.add('gray');
  } else {
    document.querySelector('html').classList.remove('gray');
  }

  let { title, needLogin } = to.meta;
  let { isLogin } = store.state;
  document.title = title;
  if (needLogin && !isLogin) {
    next({
      path: "/login"
    });
  } else {
    next();
  }
});

export default router;
